import { capitalize } from 'lodash';
import { Bundle } from '@upstart/harmony/lib/legos/penTypes';
import {
  getInStoreSelection,
  getOnlineSelection,
} from '@upstart/harmony/lib/pen-utils';

export const selectionTypeInStore = (
  _cell: string | undefined,
  row: Bundle,
) => {
  if (_cell) {
    return capitalize(_cell);
  }
  return capitalize(getInStoreSelection(row));
};

export const selectionTypeOnline = (_cell: string | undefined, row: Bundle) => {
  if (_cell) {
    return capitalize(_cell);
  }

  return capitalize(getOnlineSelection(row));
};
